"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPatrimoineRevenusCorporationGroupsTrads = void 0;
exports.EPatrimoineRevenusCorporationGroupsTrads = {
    corporateAccounting: "Comptabilité et fiscalité de votre société",
    beneficieConventionsFiscalesCorporation: "Avez-vous droit aux avantages des accords fiscaux qui permettent d’éviter une double imposition de vos revenus ?",
    nbSalariesCorporation: "Nombre de salariés",
    montantImpotAnneePrecedenteCorporation: "Montant de l'impôt N-1",
    montantIFIAnneePrecedenteCorporation: "Montant de l'IFI N-1",
    patrimoineCorporation: "Patrimoine de la société",
    compositionPatrimoineCorporation: "Composition du patrimoine",
    situationFinanciereCorporation: "Situation financière (N-1)",
    originePatrimoineCorporation: "Origine du patrimoine",
    revenusAnnuelsBrutsCorporation: "Revenus annuels bruts (chiffre d'affaire N-1)",
    compositionRevenusSocieteCorporation: "Composition du revenu de la société",
    situationFinancierePermetPlacerCorporation: "La situation financière de votre société lui permet-elle de placer une partie de son résultat ?",
    partInvestissementPatrimoineGlobalCorporation: "Part de cet investissement dans le patrimoine global",
    chargeEmpruntImmobilierAnnuelleCorporation: "Charge d'emprunt immobilier annuelle",
    chargeAutreEmpruntAnnuelleCorporation: "Charge d'autre emprunt annuelle",
    categorisationMifCorporation: "Categorisation MIF",
    societeCoteeCorporation: "La société est-elle cotée ou filale d'une société cotée?",
    societeListeeCodeMonetaireCorporation: "Société listée à l'article L.561-2 du Code monétaire et financier",
    societeUsPersonCorporation: 'La société est-elle considérée comme une "us person" au sens de la règlementation américaine?',
    statutFactaCrsCorporation: "Statut fatca et crs",
    detientPlusDroitsVoteCorporation: "La société ou son groupe est-elle domiciliée ou a-t-elle un bureau dans un MSC (pays faisant l'objet de sanctions internationales) ? ",
    activeEnDehorsUeCorporation: "La société a-t'elle une activité en dehors de l'union européenne ?",
    secteurActiviteCorporation: "Secteur d'activité",
};
